import React from 'react'

export default function Favorites () {
  return (
    <div className="content">
      <h1>Избранные пестициды</h1>
    </div>
  )
}